module.exports = __webpack_public_path__ + "static/Nicole-Rhoton-8a0d5e47e67d85fddb69b88b86521a02.jpg";